import { initialize } from '@guiker/i18n'
export * from '@guiker/i18n'

import en from './en'
import fr from './fr'
import zh from './zh'

const i18n = initialize({
  resources: {
    en,
    fr,
    zh,
  },
})

export { i18n }
